import { render, staticRenderFns } from "./WithoutHeadingStyle.vue?vue&type=template&id=b492f0d6"
import script from "./WithoutHeadingStyle.vue?vue&type=script&lang=js"
export * from "./WithoutHeadingStyle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports